var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('div',{staticClass:"all darker"},[_c('top-nav-bar'),_c('router-view',{staticClass:"padding-top-nav"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }